import { BaseExtension, NodeSpec } from '@lyearn/lygo-core';

import { NODE_NAME } from './consts';
import plugins from './plugins';

export default class Text extends BaseExtension {
  get name(): string {
    return NODE_NAME;
  }

  plugins = plugins;
}
